import { EmojiRate } from '@/models';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EmotionIcon extends Vue {
  @Prop() emoji: EmojiRate;

  get iconClass(): string {
    return `emotion-icon__${this.emoji?.icon}${this.emoji?.isActive ? '-active' : ''}`;
  }

  onIconClicked(): void {
    this.$emit(`onIconClicked`, this.emoji);
  }
}
